import { useDispatch } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import { logout } from "./redux/reducers/AuthReducer";
import { useEffect } from "react";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "user" && e.newValue === null) {
        // Another tab just logged out
        dispatch(logout());
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [dispatch]);

  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
